<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from './SolarFormData';
    import Select from '$components/Form/Select.svelte';
    import MeltMultiSelect from '$components/Form/MeltMultiSelect.svelte';
    import find from 'lodash/find';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const averageConsumptionOrEstimatedNeedsOptions = [
        `Moins de 1 kW (éclairage basique, petit frigo…)`,
        `1 à 5 kW (maison, petit commerce…)`,
        `5 à 20 kW (PME, pompes, équipements lourds)`,
        `Plus de 20 kW (grandes installations)`,
    ].map((v) => ({ label: v, value: v }));

    const requestTypeOptions = [
        `Installation pour maison individuelle`,
        `Installation pour entreprise`,
        `Projet agricole (pompe, irrigation)`,
        `Projet institutionnel (école, hôpital…)`,
        `Vente de matériel uniquement`,
        `Autre (à préciser dans votre message plus bas)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const mainObjectiveOptions = [
        `Réduire la facture d’électricité`,
        `Devenir autonome (off-grid)`,
        `Sécuriser l’alimentation (coupures fréquentes)`,
        `Valoriser un bâtiment ou terrain`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const projectStartDateOptions = [
        `Dès que possible`,
        `Dans 1 à 3 mois`,
        `Dans 3 à 6 mois`,
        `Plus tard`,
        `Juste pour information pour le moment`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.requestType}
        class=""
        let:field
        let:id
        label={`Type de demande`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={requestTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.averageConsumptionOrEstimatedNeeds}
        class=""
        let:field
        let:id
        label={`Consommation moyenne ou besoins estimés`}
    >
        <MeltMultiSelect
            {form}
            {field}
            {id}
            placeholder=""
            options={averageConsumptionOrEstimatedNeedsOptions}
            valueToOption={(v) => ({
                value: v,
                label:
                    find(averageConsumptionOrEstimatedNeedsOptions, (o) => o.value === v)
                        ?.label ?? '',
            })}
        />
    </Row>

    <Row
        {form}
        field={fields.mainObjective}
        class=""
        let:field
        let:id
        label={`Quel est votre objectif principal ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @2xl:grid-cols-2 gap-x-8"
            choices={mainObjectiveOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.projectStartDate}
        class=""
        let:field
        let:id
        label={`Quand souhaitez-vous démarrer le projet ?`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={projectStartDateOptions}
        />
    </Row>
</div>
